
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"3791.4 -17279.6 12.227 12.199"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_274_36","data-name":"Symbol 274 – 36","transform":"translate(-525 -427.842)","opacity":".54"}},[_c('g',{attrs:{"id":"Group_12536","data-name":"Group 12536","transform":"translate(3357 -18305)"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Path_19901","d":"M11.265 3.132H6.16a.466.466 0 0 1-.421-.269l-.681-1.424A.763.763 0 0 0 4.359 1h-2.6A.763.763 0 0 0 1 1.77v9.468a.761.761 0 0 0 .761.762h9.5a.761.761 0 0 0 .761-.761V3.893a.761.761 0 0 0-.757-.761z","data-name":"Path 19901","transform":"translate(959 1452.842)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_19902","d":"M22.588 72.6h-6.539c-2.042 0-2.428 1.388-2.714 2.275s-.735 2.311-.735 2.311","data-name":"Path 19902","transform":"translate(948.439 1387.655)"}})])])])
          )
        }
      }
    